"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var auto_1 = require("chart.js/auto");
var ajax_1 = require("rxjs/ajax");
var rxjs_1 = require("rxjs");
var dayjs = require("dayjs");
var chartjsOptions_1 = require("../utils/chartjs/chartjsOptions");
var operators_1 = require("rxjs/operators");
var DATE_FORMAT = "DD MMM YYYY";
var Charts = /** @class */ (function () {
    function Charts() {
    }
    Charts.prototype.onLoad = function ($element) {
        this.$chartSection = this.$element.$(".ChartSection");
        this.isChartHidden = !!document.querySelector('.no-graph');
        this.$variazioneGiornaliera = $element.$(".variazione-giornaliera .value");
        this.$valoreQuotidiano = $element.$(".valore-quotidiano .value");
        this.$valoreQuotidianoDate = $element.$(".valore-quotidiano .date");
        this.$valoreChart = $element.$(".valore-chart");
        this.$chartCanvas = $element.$(".ChartSection__data__chart");
        this.apiEndpoint = $element === null || $element === void 0 ? void 0 : $element.dataset.fundEndpoint;
        this.$loader = this.$element.$(".Loader");
        this.$yearSelectors = $element.$$(".ChartSection__data__selector span");
        // this.$isin = $element.$(".ChartSection__info__table .isin .value");
        this.$riskLevel = $element.$(".ChartSection__risk-level__content .levels");
        this.yearsRangeSelector();
        this.fetchDataOnLoad(); // Disable this for testing
    };
    /***
     Fetch the data for the chart on load
     The client has requested only ONE fetch so we fetch it with with the maximum number of months (60)
     and we sort the data by ourself :(
     ***/
    Charts.prototype.fetchDataOnLoad = function () {
        var _this = this;
        (0, ajax_1.ajax)({
            url: "".concat(this.apiEndpoint, "?numeroMesi=60"),
            method: "GET"
        })
            .pipe((0, operators_1.map)(function (_a) {
            var response = _a.response, status = _a.status;
            if (status !== 200)
                throw new Error("Chiamata andata in errore");
            return response;
        }), (0, operators_1.catchError)(function (error) { return (0, rxjs_1.of)(error.status); }))
            .subscribe(function (response) {
            var productHistoryMonths = response.productHistoryMonths, productHistoryHalfMonth = response.productHistoryHalfMonth, lastShareRate = response.lastShareRate, dailyVariation = response.dailyVariation, productISIN = response.productISIN, riskLevel = response.riskLevel, time = response.lastShareUpdateDate.time;
            _this.isHidden = Object.keys(productHistoryHalfMonth).length <= 0;
            _this.updateDOMWithData(lastShareRate, dailyVariation, productISIN, time);
            _this.productHistoryMonths = _this.isHidden ? productHistoryMonths : productHistoryHalfMonth;
            _this.productHistoryHalfMonths = productHistoryHalfMonth;
            if (_this.isHidden) {
                _this.$element.$(".ChartSection__data__selector").style.display = 'none';
            }
            _this.generateRiskLevel(riskLevel);
            _this.generateRangeOfDates();
            if (_this.$loader) {
                _this.$loader.style.display = "none";
            }
            _this.$chartSection.style.display = "flex";
            if (_this.isChartHidden) {
                document.querySelector('.ChartSection__graph').remove();
            }
        });
    };
    Charts.prototype.updateDOMWithData = function (lastShareRate, dailyVariation, productISIN, time) {
        var formattedLastShareUpdateDate = dayjs(time).format(DATE_FORMAT);
        // Set valore quotidiano value
        this.$valoreQuotidiano &&
            (this.$valoreQuotidiano.innerHTML = "\u20AC ".concat(Number(lastShareRate).toFixed(2)));
        // Set valore quotidiano update date
        this.$valoreQuotidianoDate &&
            (this.$valoreQuotidianoDate.innerHTML = formattedLastShareUpdateDate);
        // Set variazione giornaliera
        this.$variazioneGiornaliera &&
            (this.$variazioneGiornaliera.innerHTML = "\n      <svg class=\"svg\">\n        <use class=\"arrow-up-down\" xlink:href=\"".concat(Number(dailyVariation) < 1 ? "#arrow-icon-down" : "#arrow-icon-up", "\"></use>\n      </svg>").concat(Number(dailyVariation).toFixed(2), "%"));
        // // Set ISIN
        // this.$isin && (this.$isin.innerHTML = productISIN);
    };
    Charts.prototype.generateRangeOfDates = function (increment, yearsToDisplay) {
        var _this = this;
        // Disable this for testing
        if (!this.productHistoryMonths) {
            return;
        }
        var _a = [
            Object.keys(this.productHistoryMonths),
            Object.values(this.productHistoryMonths),
        ], keys = _a[0], values = _a[1]; // PASS TEST OBJECT HERE FOR TESTING WITHOUT CALLING THE API
        // New object easier to manage
        var dataObject = keys
            .map(function (date) { return dayjs(date.replace("UTC", "")).format(DATE_FORMAT); })
            .reduce(function (acc, currVal, currIndex) {
            return __spreadArray(__spreadArray([], acc, true), [
                {
                    fullDate: currVal,
                    month: dayjs(currVal).format("M"),
                    // Convert year to a int for easier comparison later
                    year: parseInt(dayjs(currVal).format("YYYY")),
                    value: values[currIndex]
                },
            ], false);
        }, []);
        // Get the last object in the array of object
        // const lastYearInArray = dataObject[dataObject.length - 1];
        // OR
        var lastYearInArray = dataObject.slice(-1)[0];
        this.lastYearInArray = lastYearInArray;
        /*
          Starting from the latest value from the latest object in the array
          calculates the most recent "year" minus the number of years we want to subtract.
          We also convert the string to a number.
          We pass 0 as default value, so it will select the latest range of values for the current year
          (ex: from first date in 2021 to latest date in 2021)
        */
        var subtractedYear = function (year) {
            if (year === void 0) { year = yearsToDisplay !== null && yearsToDisplay !== void 0 ? yearsToDisplay : 0; }
            return lastYearInArray.year - year;
        };
        if (increment) {
            this.selectedYear && (this.selectedYear = this.selectedYear + 1);
        }
        else {
            this.selectedYear = subtractedYear();
        }
        /*
          Gets the first year in the array of objects which matches the "subtractedYear" value
          and returns its index
        */
        var indexOfSelectedYear = dataObject.findIndex(function (object) { return object.year === _this.selectedYear &&
            (_this.selectedYear === new Date().getFullYear() ||
                _this.selectedYear !== new Date().getFullYear() && (new Date().getMonth() === +object.month ||
                    _this.selectedYear !== new Date().getFullYear() && new Date().getMonth() === 0 && +object.month === 12)); });
        /*
          Slice the array of object to a range that goes from the selected year
          to the last element in the array (current year)
        */
        var filteredArray = indexOfSelectedYear !== -1
            ? dataObject.slice(indexOfSelectedYear, dataObject.length)
            : [];
        /* Recursively re-run this function in case the function couldn't find the first
        year in the array. We don't want to throw an error or anything, we will show just the possibile range of data */
        return indexOfSelectedYear === -1
            ? this.generateRangeOfDates(true)
            : this.generateChart(filteredArray);
    };
    Charts.prototype.generateRiskLevel = function (riskLevel) {
        for (var i = 0; i < 7; i++) {
            var riskSpan = document.createElement("span");
            var hasRiskLevel = i < riskLevel;
            riskSpan.className = "risk-level-indicator ".concat(hasRiskLevel ? "--active" : "");
            this.$riskLevel && this.$riskLevel.appendChild(riskSpan);
        }
    };
    Charts.prototype.generateChart = function (data) {
        var _this = this;
        if (!data || data.length === 0) {
            return;
        }
        var formattedData = data.map(function (d) {
            return { x: d.fullDate, y: d.value };
        });
        // Destroy current chart
        this.chart && this.chart.destroy();
        // Create a new one
        var newChart = new auto_1["default"](this.$chartCanvas, {
            type: "line",
            data: {
                datasets: [
                    {
                        data: formattedData,
                        pointRadius: this.isHidden ? 0 : 5,
                        pointBackgroundColor: "#ffffff",
                        pointBorderWidth: 3,
                        fill: true,
                        backgroundColor: function (context) {
                            var chart = context.chart;
                            var ctx = chart.ctx, chartArea = chart.chartArea;
                            if (!chartArea) {
                                // This case happens on initial chart load
                                return null;
                            }
                            // Return gradient
                            return _this.getGradient(ctx, chartArea, "#fa683c59", "#fa683c03");
                        },
                        borderColor: "#f8663c",
                        tension: 0.1
                    },
                ]
            },
            options: __assign(__assign({}, chartjsOptions_1.chartjsOptions), { onHover: function (e) {
                    var dataPoints = e.chart.tooltip.dataPoints;
                    var chartValue = dataPoints && dataPoints[0].raw;
                    var _a = chartValue !== null && chartValue !== void 0 ? chartValue : {}, _b = _a.x, date = _b === void 0 ? null : _b, _c = _a.y, value = _c === void 0 ? null : _c;
                    _this.$valoreChart.innerHTML = value && date
                        ? "<span>\u20AC ".concat((value !== null && value !== void 0 ? value : 0).toFixed(2), "</span><span>").concat(date, "</span>") : '';
                } })
        });
        // Assign the new one
        this.chart = newChart;
    };
    // Generate a gradient that cover the whole chart with the assigned colour
    Charts.prototype.getGradient = function (ctx, chartArea, startColor, endColor) {
        var chartHeight = chartArea.bottom - chartArea.top;
        var gradient = ctx.createLinearGradient(0, 0, 0, chartHeight);
        gradient.addColorStop(0, startColor);
        gradient.addColorStop(1, endColor);
        return gradient;
    };
    // Fetch the data with different parameters to select the number of years to display
    Charts.prototype.yearsRangeSelector = function () {
        var _this = this;
        var overlay = document.querySelector('.no-graph-overlay');
        this.$yearSelectors &&
            this.$yearSelectors.forEach(function (e) {
                (0, rxjs_1.fromEvent)(e, "click").subscribe(function () {
                    var isVisible = e.dataset.isVisible;
                    overlay.classList[isVisible === 'false' ? 'add' : 'remove']('--visible');
                    var yearRange = parseInt(e.dataset.yearRange);
                    var id = e.id;
                    _this.$yearSelectors.forEach(function (element) {
                        element.$classAddOrRemoveIf(id === element.id, "--active");
                    });
                    if (isVisible === 'false')
                        return;
                    _this.generateRangeOfDates(false, yearRange);
                });
            });
    };
    Charts = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".SingleFund",
            isElementArray: false
        })
    ], Charts);
    return Charts;
}());
new Charts();
// DISCARDED BUT USEFUL IN THE FUTURE
// fetchToken() {
//   // Wordpress action
//   const data = new FormData();
//   data.append("action", "twG5Data");
//   ajax({
//     url: API_URL,
//     method: "POST",
//     body: data,
//   })
//     .pipe(
//       take(3),
//       map(({ response: { token, error } }) => {
//         this.$token = token;
//         this.fetchDataOnLoad(token);
//       }),
//       catchError((error) =>
//         of({
//           type: 401,
//           payload: error.xhr.response,
//           error: true,
//         })
//       )
//     )
//     .subscribe();
// }
